module.exports = {"532622101":"江那镇","532622102":"平远镇","532622103":"稼依镇","532622104":"阿猛镇","532622201":"阿舍彝族乡","532622202":"维末彝族乡","532622203":"盘龙彝族乡","532622204":"八嘎乡","532622205":"者腊乡","532622206":"蚌峨乡","532622207":"干河彝族乡","532622501":"平远管理区","532622502":"稼依管理区","532622503":"回龙管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532622.json
// module id = 2447
// module chunks = 0